const UserType = {
  GET_USERS: 'GET_USERS',
  GET_USER: 'GET_USER',
  CREATE_USER: 'CRAETE_USER',
  UPDATE_USER: 'UPDATE_USER',
  DELETE_USER: 'DELETE_USER',
}

export default UserType
